import { Search } from "lucide-react";
import { useEffect, useState } from "react";

import { useDebouncedValue } from "@/hooks/useDebouncedValue";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface SearchInputProps {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  placeholder?: string;
  delayMs?: number;
}

export function SearchInput({
  value,
  onChange,
  placeholder = "Cerca oggetto, titolo o mittente...",
  delayMs = 300,
}: SearchInputProps) {
  const [local, setLocal] = useState(value ?? "");
  const debounced = useDebouncedValue(local, delayMs);

  // Reset local state when the external value is cleared from outside
  // (e.g. via "Clear filters" button or back/forward navigation).
  useEffect(() => {
    setLocal(value ?? "");
  }, [value]);

  useEffect(() => {
    const normalized = debounced.trim();
    const next = normalized.length > 0 ? normalized : undefined;
    if (next !== value) {
      onChange(next);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounced]);

  return (
    <div className="w-full space-y-1.5 md:w-auto">
      <Label htmlFor="search" className="text-xs font-medium text-muted-foreground">
        Ricerca
      </Label>
      <div className="relative">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          id="search"
          type="search"
          className="h-9 w-full min-w-[200px] pl-8 md:w-[280px]"
          placeholder={placeholder}
          value={local}
          onChange={(e) => setLocal(e.target.value)}
        />
      </div>
    </div>
  );
}
